module.exports = __webpack_public_path__ + "static/media/Logotipo-BESplus-18.b8c28160.png";